<template>
  <div>
    <el-dialog title="确认收货" :visible.sync="formVisible" :close-on-click-modal="false" width="1200px">
      <el-form v-loading="fullscreenLoading" ref="dataForm" :rules="formRules" :model="form" label-position="right" label-width="120px">
        <template>
          <el-form-item label="售后商品：" required class="width100">
            <span class="hint1" style="color: red;">以下都是必填项</span>
            <div class="table-list mt20">
              <div class="spec-head">
                <div class="sp-col flex2">售后商品</div>
                <div class="sp-col flex2">平台匹配商品</div>
                <div class="sp-col">验货数量</div>
                <div class="sp-col">零售价格</div>
                <div class="sp-col">入库信息</div>
                <div class="sp-col">批次号</div>
                <div class="sp-col">有效期</div>
                <div class="sp-col flex05">操作</div>
              </div>
              <div class="spec-item" v-for="(it, idx) in form.goodsList" :key="idx">
                <el-form-item class="sp-col flex2" label-width="0">
                  <span class="goods-name"> {{ it.afterGoodsName ? `${it.afterGoodsName}*${it.afterGoodsCount || 1}` : '' }}</span>
                  <!-- <el-select v-else style="border:none" v-model="it.id" placeholder="请选择售后商品" popper-class="popperClass" clearable size="small" @change="getAfterGoods(idx)">
                    <el-option v-for="item in sysGoods" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item class="sp-col flex2" label-width="0" :prop="`goodsList[${idx}].platformProductIdArr`" :rules="{required: true,message: '请选择',trigger: 'change',}">

                  <el-cascader v-model="it.platformProductIdArr" filterable :props="cascaderProps" :options="sysGoods" placeholder="请选择平台匹配商品" clearable @expand-change="(val) => handleExpandChange(val, idx)" @change="getGoodsGG(idx)" />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].acceptanceQuantity`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-input v-model="it.acceptanceQuantity" placeholder="请输入验货数量" />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].retailPrice`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-input v-model="it.retailPrice" placeholder="请输入零售价格" disabled />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].inBoundQuantity`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-input v-model="it.inBoundQuantity" placeholder="请输入入库信息" />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].batchNumber`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-input v-model="it.batchNumber" placeholder="请输入批次号" />
                </el-form-item>
                <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].expirationDate`" :rules="{required: true,message: '请选择',trigger: 'change',}">
                  <el-date-picker v-model="it.expirationDate" type="date" placeholder="请选择" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <div class="sp-col oper-icon flex05">
                  <i class="el-icon-minus" @click="handleDeleteItem(idx)" v-if="form.goodsList.length > 1"></i>
                  <i class="el-icon-plus" @click="handleAddItem"></i>
                </div>
              </div>
            </div>
            <!-- 汇总信息 -->
            <div class="summary-section">
              <div class="summary-item">
                <span class="summary-label">总验货数量:</span>
                <span class="summary-value">{{ totalAcceptanceQuantity }}件</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">验货商品总价 (零售价):</span>
                <span class="summary-value">{{ totalRetailPrice }}元</span>
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="申请原因：" prop="refundMoney" v-if="this.orderSourceType">
            <el-input v-model="form.refundMoney" placeholder="请输入申请原因" />
          </el-form-item> -->
          <el-form-item label="附件(最多9张)：" prop="attachment">
            <moreImageUpload v-model="form.attachment" :limit="9" />
          </el-form-item>
          <el-form-item label="备注：" prop="remarks">
            <el-input v-model="form.remarks" placeholder="请输入备注" />
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="doCreate()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import sysGoodsApi from '@/api/sys/sysGoods'
import MoreImageUpload from "@/components/MoreImageUpload";
function initFormBean() {
  const formBean = {
    id: null, // 添加id字段
    attachment: [], // 修改为attachment
    goodsList: [{ // 修改为goodsList
      acceptanceQuantity: '', // 修改字段名
      afterGoodsName: '', // 修改字段名
      batchNumber: '',
      inBoundQuantity: '',
      expirationDate: '', // 修改为数字类型
      id: null,
      platformProductIdArr: []
    }],
    remarks: '' // 修改为remarks
  }
  return formBean
}
export default {
  components: {
    MoreImageUpload
  },
  data() {
    return {
      cascaderProps: {
        label: 'name',
        value: 'id',
        children: 'children'
      },
      formRules: {
        customerId: [{ required: true, message: '请选择认领人员', trigger: 'change' }],
        logisticsNumber: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
        afterMethod: [{ required: true, message: '请选择售后方式', trigger: 'change' }],
        customerAddressId: [{ required: true, message: '请选择收货地址', trigger: 'change' }],
      },
      form: initFormBean(),
      formVisible: false,
      detailGoodsList: [],
      selectItems: [],
      sysGoods: [],
      fullscreenLoading: false,
      orderSourceType: 0,    //1 是从待认领售后订单页面来的
      userList: [],
      isRepSub: false,
      userAddrList: []
    };
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
  },
  computed: {
    // 计算总验货数量
    totalAcceptanceQuantity() {
      return this.form.goodsList.reduce((total, item) => {
        const quantity = parseFloat(item.acceptanceQuantity) || 0;
        return total + quantity;
      }, 0);
    },
    // 计算验货商品总价
    totalRetailPrice() {
      return this.form.goodsList.reduce((total, item) => {
        const quantity = parseFloat(item.acceptanceQuantity) || 0;
        const price = parseFloat(item.retailPrice) || 0;
        return total + (quantity * price);
      }, 0);
    }
  },
  watch: {

  },
  methods: {
    // getAfterGoods(idx) {
    //   const selectedGoodsId = this.form.goodsList[idx].id;
    //   if (selectedGoodsId) {
    //     // 在商品列表中查找对应的商品名称
    //     const foundGoods = this.sysGoods.find(item => item.id === selectedGoodsId);
    //     if (foundGoods) {
    //       // 使用 $set 确保响应式更新
    //       this.$set(this.form.goodsList[idx], 'afterGoodsName', foundGoods.name);
    //     }
    //   } else {
    //     // 如果没有选择商品，清空商品名称
    //     this.$set(this.form.goodsList[idx], 'afterGoodsName', '');
    //   }
    // },
    handleDeleteItem(index) {
      this.form.goodsList.splice(index, 1) // 修改为goodsList
    },
    handleAddItem() {
      this.form.goodsList.push({ // 修改为goodsList
        acceptanceQuantity: '',
        afterGoodsName: '',
        batchNumber: '',
        inBoundQuantity: '',
        expirationDate: '',
        id: null,
        platformProductIdArr: [],
        isApp: 0
      })
    },
    resetForm() {
      this.form = initFormBean()
    },
    handleAddOrder(row, type) {
      if (type) this.orderSourceType = type;
      this.getDetails(row.id);

    },
    getDetails(id) {
      this.resetForm()
      this.form.id = id;
      goodsOrderApi.getAfterDetail(id).then(({ data }) => {
        let arr = [];
        if (data.goodsList) {
          data.goodsList && data.goodsList.forEach(it => {
            arr.push({
              id: it.id,
              acceptanceQuantity: it.acceptanceQuantity, // 修改字段名
              afterGoodsName: it.afterGoodsName, // 修改字段名
              afterGoodsCount: it.afterGoodsCount, // 修改字段名
              batchNumber: it.batchNumber,
              inBoundQuantity: it.inBoundQuantity,
              expirationDate: it.expirationDate, // 修改为数字类型
              platformProductIdArr: it.platformProductId && it.platformCombineId ? [it.platformProductId, it.platformCombineId] : [],
              isApp: it.applicantType ? 0 : 1,
              retailPrice: it.retailPrice
            });
          })
        } else {
          arr.push({
            acceptanceQuantity: '', afterGoodsName: '', batchNumber: '',
            inBoundQuantity: '', expirationDate: '', id: null, platformProductIdArr: [], isApp: 0
          })
        }
        this.$set(this.form, 'attachment', this.clacArrObj(data.attachment))
        this.$set(this.form, 'remarks', data.remarks)


        this.$set(this.form, 'goodsList', arr)
        this.formVisible = true;
        this.selectItems = arr;
        this.getGoods();
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    clacArrObj(str) {
      if (!str) return []
      let arr = str.split(',')
      let newArr = []
      arr.forEach((item, index) => {
        newArr.push({ url: item, uid: 'a_' + index })
      })
      return newArr
    },
    getGoods() {
      sysGoodsApi.getGoodRecomList().then(({ data }) => {
        this.sysGoods = data
        this.sysGoods.forEach(item => {
          item.name = item.name + (item.aliasName ? ' [' + item.aliasName + ']' : '')
          item.children = item.specValueList.map(it => ({
            id: it.id,
            name: item.spec || '无规格值',
            retailPrice: it.retailPrice
          }))
        })
      })
    },
    handleExpandChange(val, idx) {
      if (val && val.length === 1) {
        const parent = this.sysGoods.find(item => item.id === val[0])
        if (parent && parent.children && parent.children.length === 1) {
          this.$set(this.form.goodsList[idx], 'platformProductIdArr', [val[0], parent.children[0].id])
          this.getGoodsGG(idx)
        }
      }
    },
    getGoodsGG(idx) {
      const selectedValue = this.form.goodsList[idx].platformProductIdArr;
      let name = this.sysGoods.find(item => item.id === selectedValue[0]).name;
      if (!this.form.goodsList[idx].id) {
        this.$set(this.form.goodsList[idx], 'afterGoodsName', name);
      }
      if (selectedValue && selectedValue.length > 0) {
        // 获取选中的商品ID（级联选择器的最后一个值）
        const selectedProductId = selectedValue[selectedValue.length - 1];
        // 在商品列表中查找对应的零售价格
        this.sysGoods.forEach(item => {
          if (item.children) {
            const foundChild = item.children.find(child => child.id === selectedProductId);
            if (foundChild) {
              // 使用 $set 确保响应式更新
              this.$set(this.form.goodsList[idx], 'retailPrice', foundChild.retailPrice);

            }
          }
        });
      } else {
        // 如果没有选择商品，清空零售价
        this.$set(this.form.goodsList[idx], 'afterGoodsName', '');
        this.$set(this.form.goodsList[idx], 'retailPrice', '');
      }
      this.$forceUpdate();
    },

    closeDialog() {
      this.fullscreenLoading = false;
      this.formVisible = false;
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.attachment = params.attachment.length ? params.attachment.map(banner => banner.url).toString() : ''
          // 处理匹配商品数据
          params.goodsList.forEach(item => {
            if (item.platformProductIdArr && Array.isArray(item.platformProductIdArr)) {
              item.platformProductId = item.platformProductIdArr[0];
              item.platformCombineId = item.platformProductIdArr[1];
            }
            item.acceptanceQuantity = +item.acceptanceQuantity
            delete item.platformProductIdArr
            delete item.isApp
          });
          if (this.fullscreenLoading) return;
          if (this.isRepSub) return
          this.isRepSub = true
          this.fullscreenLoading = true;
          goodsOrderApi.afterSigned(params).then((data) => {
            this.fullscreenLoading = false;
            this.isRepSub = false
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(data) {
      if (data.code === '0') {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
      } else {
        this.$message.error(data.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.reimbursement {
  padding: 0 50px;
}
.dialog-footer {
  // display: flex;
  // justify-content: center;
  // padding: 20px 0;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  // padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    width: 100px;
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex: 2.5;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #5dbde7;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;
    &.flex05 {
      flex: 0.5;
    }
    &.flex2 {
      flex: 2.5;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        .el-input__inner {
          border: none !important;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.popperClass {
  border-color: #fff !important;
}
.spec-item {
  .el-select .el-input {
    box-shadow: none !important;
    border: none !important;
  }
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
.goods-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}
::v-deep .el-form-item__content {
  line-height: initial;
}

/* 汇总区域样式 */
.summary-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 15px 20px;
  background-color: #f0f8ff;
  // border: 1px solid #5dbde7;
  border-radius: 4px;
  gap: 30px;
}

.summary-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.summary-label {
  color: #333;
  margin-right: 8px;
}

.summary-value {
  color: #ff4949;
  font-weight: bold;
  font-size: 16px;
}
</style>